import axios from '@axios'

const PREFIX = '/estados'

export default {

  getEstadosResumidos(filtro, externo) {
    if (externo) {
      return axios.post(`${PREFIX}/portal-propostas/resumido`, filtro)
    }
    return axios.post(`${PREFIX}/resumido`, filtro)
  },
}
